/**
 * Actions you can make on widgets
 * @module  {Actions} widgetActions
 */
export const UPDATE_WIDGET = '@@widgets/UPDATE'
export const SIDE_UPDATE_WIDGET = '@@widgets/SIDE_UPDATE'
export const UPDATE_ALL_WIDGETS = '@@widgets/UPDATE_ALL'

/**
 * Updates all the widgets
 *
 * @param {Object} widgets      The updated widgets
 * @return {Function}           Dispatches an UPDATE_ALL_WIDGETS action
 */
export const updateAllWidgets = widgets => ({
  type: UPDATE_ALL_WIDGETS,
  widgets
})

/**
 * Modifies the widgets with the updated values
 *
 * @param {string} widgetName     The name of the widget to update
 * @param {Object} updateBody     An object containing the properties and values to assign to the widget
 * @param {Object} options        Update options
 * @param {Boolean} collateral    Collateral update flag
 * @return {Function}             Dispatches an update widget action
 */
export const updateWidget = (widgetName, updateBody, { collateral } = {}) => (
  dispatch,
  getState
) => {
  const { widgets } = getState()
  return dispatch({
    type: !collateral ? UPDATE_WIDGET : SIDE_UPDATE_WIDGET,
    widget: { ...widgets[widgetName], ...updateBody }
  })
}



// WEBPACK FOOTER //
// ./state/actions/widgetsActions.js